import ChartLine from './Line.vue';

const charts = { ChartLine };

export default charts;

export { ChartLine };
